import { render, staticRenderFns } from "./CloseDialog.vue?vue&type=template&id=255ebb28&scoped=true&"
import script from "./CloseDialog.vue?vue&type=script&lang=ts&"
export * from "./CloseDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255ebb28",
  null
  
)

export default component.exports